import { motion } from "framer-motion";

const Skills = () => {
  const skillCategories = [
    {
      title: "Languages & Frameworks",
      skills: [
        { name: "React / React Native", level: 95 },
        { name: "TypeScript / JS (ES6+)", level: 90 },
        { name: "Next.js", level: 85 },
      ],
    },
    {
      title: "State & Data Management",
      skills: [
        { name: "Zustand", level: 95 },
        { name: "TanStack Query", level: 90 },
        { name: "Redux Toolkit", level: 85 },
      ],
    },
  ];

  const tools = [
    "Expo",
    "Tailwind CSS",
    "NativeWind",
    "Shadcn UI",
    "Material UI",
    "Styled-Components",
    "SASS",
    "CSS Modules",
    "Axios",
    "Zod",
    "React-hook-form",
    "AES-GCM",
    "Sentry",
    "Git / GitHub / GitLab",
    "Vercel",
    "App Store Connect",
    "Google Play Console",
  ];

  return (
    <section id="skills" className="w-full pt-20 ">
      <div className="mb-12 md:mb-20 flex flex-col justify-start gap-4 border-b border-black/10 dark:border-white/10 pb-8">
        <span className="text-[13px] md:text-sm font-mono text-black/50 dark:text-white/50 uppercase tracking-widest">
          Arsenal
        </span>
        <h2 className="text-3xl sm:text-4xl md:text-[42px] font-display font-medium tracking-[-0.02em] leading-tight text-black dark:text-white max-w-2xl">
          The tools I use to build.
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
        {/* Progress Bars */}
        <div className="flex flex-col gap-12 lg:max-w-xl">
          {skillCategories.map((category, i) => (
            <motion.div
              key={category.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{
                duration: 0.6,
                delay: i * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="flex flex-col"
            >
              <h3 className="text-[13px] font-mono text-black/50 dark:text-white/50 uppercase tracking-widest mb-8 pb-4 border-b border-black/10 dark:border-white/10">
                {category.title}
              </h3>
              <div className="flex flex-col gap-6">
                {category.skills.map((skill) => (
                  <div key={skill.name} className="w-full">
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-lg md:text-xl font-display font-medium tracking-tight text-black/80 dark:text-white/80 transition-colors">
                        {skill.name}
                      </span>
                      <span className="text-xs font-mono text-black/40 dark:text-white/40 transition-colors">
                        {skill.level}%
                      </span>
                    </div>
                    <div className="h-[1px] w-full bg-black/10 dark:bg-white/10 relative overflow-hidden">
                      <motion.div
                        initial={{ width: 0 }}
                        whileInView={{ width: `${skill.level}%` }}
                        viewport={{ once: true }}
                        transition={{
                          duration: 1.5,
                          delay: 0.2 + i * 0.1,
                          ease: [0.16, 1, 0.3, 1],
                        }}
                        className="absolute top-0 left-0 h-full bg-black dark:bg-white"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Tool Tags */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="bg-gray-200 dark:bg-[#0a0a0a] p-8 md:p-12 border border-black/5 dark:border-white/5"
        >
          <h4 className="text-sm font-mono tracking-[0.2em] uppercase text-black/40 dark:text-white/40 mb-10">
            {" Tooling & Ecosystem"}
          </h4>
          <div className="flex flex-wrap gap-3">
            {tools.map((tool) => (
              <span
                key={tool}
                className="px-4 py-3 text-[11px] md:text-xs font-mono tracking-widest uppercase border border-black/10 dark:border-white/10 text-black/60 dark:text-white/60 hover:text-white dark:hover:text-black hover:bg-black dark:hover:bg-white hover:border-black dark:hover:border-white transition-all duration-300 cursor-default"
              >
                {tool}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
